<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-size: 1.17em;">I settled into the second guest chair, then immediately wanted to scoot myself away from the man next to me. Power, an almost physical force, surged around him.</span> Nothing wimpy like static that would raise a small sprinkling of goose bumps on my arm. No, this was overwhelming, like standing next to a man-sized speaker at a death metal concert. It felt like something writhed under my skin. Not painful, but a little uncomfortable in its unexpectedness.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“This is Ford Whitney, one of our graduate students.”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">It took me a moment to clear the fuzz in my brain and realize Tierney was introducing me to the guy next to me. Ford. The name fit him. Strong. Straightforward. Sexy.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">I needed to stop that kind of thinking right now. The strikes were already piling up against me. Lustful thoughts about one of the grad students was a big no-no.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?2061eb65